import {
    FASTSHIFT_PATHS,
    FASTSHIFT_PATH_KEYS,
    FASTSHIFT_BASE_URL_PROD,
    FASTSHIFT_BASE_URL_STAGING,
    FASTSHIFT_BASE_URL_DEV
} from "./constants";

export const getDomainScopedPathKeys = () =>
    Object.keys(FASTSHIFT_PATHS).filter((pathKey) =>
        FASTSHIFT_PATHS[pathKey as FASTSHIFT_PATH_KEYS].includes(":domainId")
    );

export const removeTrailingSlash = (url: string): string =>
    url.replace(/\/+$/, "");

// helper function to allow for testing
export const getFastshiftBaseUrl = (env: string) => {
    switch (env) {
        case "production":
            return FASTSHIFT_BASE_URL_PROD;
        case "staging":
            return FASTSHIFT_BASE_URL_STAGING;
        case "development":
            // development environment is not fully set up so expect errors if you use this environment
            return FASTSHIFT_BASE_URL_DEV;
        default:
            return null;
    }
};
